import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "../components/AppLayout";

const HERO = "https://images.unsplash.com/photo-1790986119054-6465d40c2584?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function AuthPage({ mode }) {
  return (
    <div className="flex min-h-screen bg-background">
      <div className="relative hidden flex-1 overflow-hidden lg:flex">
        <img src={HERO} alt="Night shift" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/50 to-transparent" />
        <div className="relative mt-auto p-12">
          <h2 className="font-heading text-5xl font-black uppercase leading-[0.95] tracking-tight">
            Every hour counted.<br /><span className="text-amber-500">Every euro clear.</span>
          </h2>
          <p className="mt-4 max-w-md text-muted-foreground">Log shifts in seconds. ShiftMate does the maths on breaks, overtime and pay.</p>
        </div>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-8 px-4 py-10" data-testid={`auth-page-${mode}`}>
        <Logo />
        {mode === "in" ? (
          <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
        ) : (
          <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
        )}
        <Link to="/" data-testid="auth-back-home" className="text-xs text-muted-foreground hover:text-foreground">← Back to home</Link>
      </div>
    </div>
  );
}
